import script from "./MiniAlien.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniAlien.vue?vue&type=script&setup=true&lang=js"

import "./MiniAlien.vue?vue&type=style&index=0&id=64b58d23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b58d23"]])

export default __exports__